import {
  DialogProvider,
  ToastContent,
  Toaster,
} from "@endya-conformite/ui-kit";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { UserSessionProvider } from "./data/session/UserSessionContext";
import { Router } from "./Router";

import "@endya-conformite/ui-kit/src/lya/style";

import "@endya-conformite/ui-kit/src/style/app.scss";
import "@endya-conformite/ui-kit/src/style/lya-lib-override.scss";

function addEnvToTitle() {
  const env = window.location.hostname
    .split(".")
    .find((part) => ["rec", "ppr", "localhost"].includes(part));
  if (env && !document.title.startsWith("[")) {
    document.title = `[${env === "localhost" ? "local" : env}] ${document.title}`;
  }
}

export function App() {
  useEffect(() => {
    addEnvToTitle();
  }, []);

  return (
    <BrowserRouter>
      <UserSessionProvider>
        <DialogProvider>
          <Toaster
            defaultHideAfter={5000}
            position={{
              vertical: "bottom",
              horizontal: "center",
            }}
            ToastContentComponent={ToastContent}
          />
          <Router />
        </DialogProvider>
      </UserSessionProvider>
    </BrowserRouter>
  );
}
